/**
 * Marks a navigation to /browse as "just signed in" (or "just set my
 * password"), so Home can send a pass-holding student straight on to the pack
 * their school issued — the Exam Ready learners who landed on /browse after
 * their first sign-in mostly clicked around the shelf and left without ever
 * opening a lesson (PostHog, Oct 2026).
 *
 * Only these arrivals redirect. A student who clicks Home in the nav, finishes
 * a lesson, or follows a breadcrumb still gets /browse — the redirect is the
 * first screen after sign-in, not a lock on the page.
 */
export const SIGN_IN_LANDING_STATE = { signInLanding: true } as const;

/**
 * The landing state for a destination restored after an email round-trip
 * (magic link, activation): only a restored Home counts as a sign-in arrival,
 * query string and fragment ignored. Anywhere else the learner asked to go
 * stays exactly where they asked.
 */
export function landingStateForPath(path: string): typeof SIGN_IN_LANDING_STATE | undefined {
  return path.split(/[?#]/, 1)[0] === '/browse' ? SIGN_IN_LANDING_STATE : undefined;
}

export function isSignInLanding(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { signInLanding?: unknown }).signInLanding === true
  );
}
